import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { MobileMenuViewImpl } from './mobilemenuview';
import { MobileMenuCSSStyleImpl } from './mobilemenucss';
import { DropDownDto, DropDownDtoImpl } from '../../../core/dto/dropdown/dropdowndto';
import { Strings } from '../../../utils/resources/strings';
import { RoutingFeatures } from '../../components/navigation/routingfeature';
import { CategoryDto } from '../../../core/dto/categories/categorydto';
import { ToolbarSearchAPIModel, ToolbarSearchAPIModelImpl } from '../toolbarwithsearch/toolbarsearchapimodel';
import { APIModelHandler, APIModel } from '../uicomponentapimodel';
import { APIFeatures } from '../../../core/util/apifeatures';
import { LanguageConst } from '../../../utils/resources/languageconst';

export interface MobileMenuComponentProps extends UIComponentProps
{
    categories: CategoryDto[];
    onLogoClicked(): void;
    // onSalathiClicked(): void;
    onDoItYourselfClicked(): void;
    onMyAccountOptionClicked(routingFeature: string): void;
    onCategoriesSelected(title: string): void;
    onLanguageChange(languageSelected: LanguageConst): void;
}

export interface MobileMenuComponentHandler extends UIComponentHandler
{
    toggleCategories(isTuneSelected: boolean): void;
    onCategoriesSelected(title: string): void;
    onMyAccountOptionClicked(dropDownDto:DropDownDto): void;
    onLanguageChange(languageConst: LanguageConst): void;
    toggleMenu(isShow: boolean): void;
}

export interface MobileMenuComponentState extends UIComponentState
{
   listOfOptions: DropDownDto[];
   categories: CategoryDto[];
   isMenuOpen: boolean;
   isTuneSelected: boolean;
}

export class MobileMenuComponent extends UIComponentImpl<MobileMenuComponentProps, MobileMenuComponentState, UIDataModel> 
implements MobileMenuComponentHandler
{
    constructor(props: MobileMenuComponentProps)
    {
        super(props);

        this.state = {isMenuOpen: false, listOfOptions: this.getListOfOptions(), categories: this.props.categories, 
        isTuneSelected: false};
    }

    componentWillReceiveProps(nextprops: MobileMenuComponentProps)
    {
        this.setState({categories: nextprops.categories});
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new MobileMenuViewImpl(applicationContext, uiComponentHandler);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ToolbarSearchAPIModelImpl(applicationContext, apiModelHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new MobileMenuCSSStyleImpl(applicationContext);
    }

    toggleCategories(isTuneSelected: boolean): void {
      this.setState({isTuneSelected: isTuneSelected});
    }

    onLanguageChange(languageConst: LanguageConst): void 
    {
        this.toggleCategories(false);
        this.toggleMenu(false);
       this.props.onLanguageChange(languageConst);
    }

    onMyAccountOptionClicked(dropDownDto:DropDownDto): void 
    {  
        if(dropDownDto.getId() === RoutingFeatures.LOGOUT)
        {
            this.toggleCategories(false);
            this.toggleMenu(false);
            (this.getView() as MobileMenuViewImpl).showLoader();
            (this.getAPIModel() as ToolbarSearchAPIModel).logout();
        }
        else if(dropDownDto.getId() === "About")
        {
           
        }
        else if(dropDownDto.getId() === RoutingFeatures.MENU_CATEGROIES)
        {
           this.toggleCategories(!this.state.isTuneSelected);
        }
        else
        {
            this.toggleCategories(false);
            this.toggleMenu(false);
            this.props.onMyAccountOptionClicked(dropDownDto.getId());
        }
    }
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        if(feature === APIFeatures.LOGOUT)
        {
            (this.getView() as MobileMenuViewImpl).dismissLoader();
             this.props.context.logout();
            this.props.onMyAccountOptionClicked(RoutingFeatures.HOME);
        }
    }
    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        if(feature === APIFeatures.LOGOUT)
        {
            this.toggleMenu(false);
            this.toggleCategories(false);
            (this.getView() as MobileMenuViewImpl).dismissLoader();
             this.props.context.logout();
            this.setState({listOfOptions: this.getListOfOptions()});
            this.props.onMyAccountOptionClicked(RoutingFeatures.HOME);
        }
    }
    onCategoriesSelected(title: string): void 
    {
        this.toggleMenu(false);
        this.toggleCategories(false);
        this.props.context.getRedirectionHandler().routeNextFeature(this.props.context.getRoutingPath() +
        "/" + RoutingFeatures.MENU_CATEGROIES+ "?category-name=" +title, false);
    }
   
    toggleMenu(isShow: boolean): void 
    {
        this.setState({isMenuOpen: isShow});
    }

    private getListOfOptions()
    {
        let dropDown1 = new DropDownDtoImpl();
        dropDown1.setId(RoutingFeatures.PROFILE);
        dropDown1.setTitle(this.props.context.getResources().getString(Strings.myprofile));
       
        let dropDown2 = new DropDownDtoImpl();
        dropDown2.setId(RoutingFeatures.TRANSACTION_HISTORY);
        dropDown2.setTitle(this.props.context.getResources().getString(Strings.history));

        let dropDown3 = new DropDownDtoImpl();
        dropDown3.setId(RoutingFeatures.WISHLIST);
        dropDown3.setTitle(this.props.context.getResources().getString(Strings.wishlist));

        let dropDown4 = new DropDownDtoImpl();
        dropDown4.setId(RoutingFeatures.MYTUNES);
        dropDown4.setTitle(this.props.context.getResources().getString(Strings.mytunes));

        let dropDown5 = new DropDownDtoImpl();
        dropDown5.setId(RoutingFeatures.CALLER_GROUP);
        dropDown5.setTitle(this.props.context.getResources().getString(Strings.caller_group));

        let dropDown6 = new DropDownDtoImpl();
        dropDown6.setId(RoutingFeatures.BLACKLIST);
        dropDown6.setTitle(this.props.context.getResources().getString(Strings.blacklist));

       let dropDown7 = new DropDownDtoImpl();
       dropDown7.setId(RoutingFeatures.LOGOUT);
       dropDown7.setTitle(this.props.context.getResources().getString(Strings.logout));

       let dropDownOption = new DropDownDtoImpl();
        dropDownOption.setId(RoutingFeatures.HOME);
        dropDownOption.setTitle(this.props.context.getResources().getString(Strings.home));

        let dropDownOption1 = new DropDownDtoImpl();
        dropDownOption1.setId("About");
        dropDownOption1.setTitle(this.props.context.getResources().getString(Strings.about));

        let dropDownOption2 = new DropDownDtoImpl();
        dropDownOption2.setId(RoutingFeatures.FAQ);
        dropDownOption2.setTitle(this.props.context.getResources().getString(Strings.faq));

        let dropDownOption3 = new DropDownDtoImpl();
        dropDownOption3.setId(RoutingFeatures.MENU_CATEGROIES);
        dropDownOption3.setTitle(this.props.context.getResources().getString(Strings.categories));

        let dropDownOption4 = new DropDownDtoImpl();
        dropDownOption4.setId(RoutingFeatures.LOGIN);
        dropDownOption4.setTitle(this.props.context.getResources().getString(Strings.signin));

       if(this.props.context.getUserContext().getIsLoggedIn())
       {
        //    return [dropDownOption, dropDown1, dropDown2, dropDownOption3, dropDown3, dropDown4, dropDown5, dropDown6, dropDownOption2, 
        //     dropDownOption1, dropDown7];
              
            return [dropDownOption, dropDown1, dropDown2, dropDownOption3, dropDown3, dropDown4, dropDownOption2, 
                dropDownOption1, dropDown7];
       }
       else
       {
        return [dropDownOption,   dropDownOption3, dropDownOption2, dropDownOption1,dropDownOption4];
       }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/mobilemenu/mobilemenucomponent.tsx